import twentyThree from './23.svg';

export const U23EligibleIcon = () => {
  return <img src={twentyThree} alt="Eligible U23" width="24" height="24" />;
};

export default U23EligibleIcon;
